// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0aa65157","453":"939b479a","667":"333a3d38"}[chunkId] + ".chunk.js";
};